import { BestSells, Header, Related, Search, Slider } from "./components";

const Home = () => {
  return (
    <div>
      <Header />
      <Search />
      <BestSells />
      <Related />
      <Slider />
    </div>
  );
};

export default Home;
